import { Autocomplete, TextField } from '@mui/material';
import { startCase } from 'lodash';

import { withProps } from '@synthetica-ai/system';
import { shipyards } from 'models/app';

const ShipyardInput = ({ value, shipyards, onChange }) => (
  <Autocomplete
    value={value}
    getOptionLabel={(option) => startCase(option.name)}
    options={shipyards}
    onChange={(_, value) => onChange(value)}
    renderInput={(params) => <TextField {...params} autoFocus variant="standard" size="small" />}
  />
);

export default withProps({
  shipyards,
})(ShipyardInput);
